'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _winresOmalomaBookingSummary = require('../winresOmalomaBookingSummary/winresOmalomaBookingSummary.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaDestinationInfo = function () {
  function WinresOmalomaDestinationInfo($rootScope, $scope, $filter, omalomaService) {
    _classCallCheck(this, WinresOmalomaDestinationInfo);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$filter = $filter;
    this.omalomaService = omalomaService;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // waiting_for_parameter - Waiting for a dynamic parameter to be set.
    // loading - Loading info.
    // ready - Info loaded.
    // error - Failed to load info.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Failed to fetch data from backend.
    this.$scope.error = null;

    this.initTemplateFields();
  }

  _createClass(WinresOmalomaDestinationInfo, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.setStatus('out', null);
      });
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.load();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      if (!this.bookingNumber) {
        console.log('[WODI] Booking number not available yet.');
        this.setStatus('waiting_for_parameter', null);
        return;
      }

      this.setStatus('loading', null);

      this.omalomaService.getDestinationInfo(this.bookingNumber).then(function (info) {
        _this2.setTemplateFields(info);
        _this2.setStatus('ready', null);
      }).catch(function (error) {
        console.error('[WODI] Failed to load booking:', error);
        _this2.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'initTemplateFields',
    value: function initTemplateFields() {
      this.$scope.description = "";
      this.$scope.transfer = "";
      this.$scope.links = [];
      this.$scope.textLength = 300;
    }
  }, {
    key: 'setTemplateFields',
    value: function setTemplateFields(info) {
      console.log('[WODI] Destination:', info.DestinationCode);
      if (info.TransferGuidelines) {
        console.log("[WODI] We got transfer guidelines");
        this.$scope.description = info.DescriptionOfDestination + '\n\n' + this.$filter('i18next')('omaloma.destination_info.transfer') + '\n\n' + info.TransferGuidelines;
      } else {
        console.log("[WODI] We got no transfer guidelines");
        this.$scope.description = info.DescriptionOfDestination;
      }
      this.$scope.transfer = info.TransferGuidelines;
      this.$scope.destinationName = info.DestinationName;
      this.$scope.links = (0, _winresOmalomaBookingSummary.externalDocuments)(info).concat((0, _winresOmalomaBookingSummary.externalDescriptions)(info));
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WODI] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WODI] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'showMoreText',
    value: function showMoreText(description) {
      this.$scope.textLength = 999999;
      $('#showmorelink').hide();
      $('#hideText').show();
    }
  }, {
    key: 'hideText',
    value: function hideText() {
      this.$scope.textLength = 300;
      $('#showmorelink').show();
      $('#hideText').hide();
    }
  }]);

  return WinresOmalomaDestinationInfo;
}();

WinresOmalomaDestinationInfo.$inject = ['$rootScope', '$scope', '$filter', 'omalomaService'];

_module3.default.component('winresOmalomaDestinationInfo', {
  template: require('./winresOmalomaDestinationInfo.html'),
  controller: WinresOmalomaDestinationInfo,
  require: {},
  bindings: {
    bookingNumber: '<'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaDestinationInfo/winresOmalomaDestinationInfo.js
// module id = 330
// module chunks = 2